<template>
    <div class="amap-wrapper">
        <el-amap class="amap-box" :plugin="plugin" vid="map" :zoom="zoom" :center="center" :events="events">
        <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult" ></el-amap-search-box>
        <el-amap-marker class="amap-marker" :position="center" vid="marker" :label="label"></el-amap-marker>
        </el-amap>
        
        <!-- <div class="adrs">
            <ul>
                <li>
                    <p class="address">{{list.address}}</p>
                    <p class="name">{{list.name}}</p>
                    <p class="position">{{list.lng}},{{list.lat}}</p>
                    <p class="city">{{list.city}}</p>
                    <p class="district">{{list.district}}</p>
                    <p class="township">{{list.township}}</p>
                </li>
            </ul>
        </div> -->
        <button type="button" class="close" @click="closeMap"><i class="iconfont icon-close fs-14"></i></button>
        <button type="button" id="submit-map" class="btn btn-complete" validate="true" @click="submitMap">提交</button>
    </div>
</template>

<style lang="sass">
    #submit-map
        position: absolute;
        right: 15px;
        bottom: 15px;
    .amap-wrapper .close
        position: absolute;
        width: 40px;
        height: 40px;
        vertical-align: middle;
        top: 15px;
        right: 15px;
        background-color: #fff;
        opacity: 1;
        border: 1px solid #5d5d5d;
        border-radius: 50%;
    .amap-wrapper .icon-close
        font-size: 20px !important;
        color: #5d5d5d;
    .amap-hidden
        display: none;
    .amap-show
        display: block;
    .amap-wrapper
        // display: none;
        position: absolute;
        width: 70%;
        height: 80%;
        z-index: 99999;
    .amap-marker-label
        left: 10px;
        top: 12px;
    .search-tips
        width: 100%;
        max-height: 200px;
    .el-vue-amap-container
        position: relative;
    .el-vue-search-box-container
        position: absolute !important;
        top: 15px;
        left: 15px;
</style>

<script>
export default {
  name: 'amapSelect',
  data () {
    var me = this
    // me.city = me.city || '珠海'
    me.city = me.city
    return {
      list: [],
      zoom: 16,
      center: [113.584672, 22.345392],
      label: {
        content: '清华科技园',
        offset: [10, 12]
      },
      events: {
        init: (o) => {
          let lng = 113.584672
          let lat = 22.345392
          me.center = [lng, lat]
          me.label = {
            content: '清华科技园',
            offset: [10, 12]
          }
          var geocoder = new AMap.Geocoder({
            radius: 100,
            extensions: 'all'
          })
          geocoder.getAddress(me.center, function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                let regeocode = result.regeocode
                let name = ''
                let content = ''
                if (typeof (regeocode.pois[0]) !== 'undefined') {
                  name = regeocode.pois[0].name
                  content = regeocode.pois[0].name
                }
                me.list = {
                  address: regeocode.formattedAddress,
                  name: name,
                  lng: lng,
                  lat: lat,
                  city: regeocode.addressComponent.city,
                  district: regeocode.addressComponent.district,
                  township: regeocode.addressComponent.township
                }
                me.label = {
                  content: content,
                  offset: [10, 12]
                }
              }
            }
          })
        },
        click (e) {
          let { lng, lat } = e.lnglat
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 100,
            extensions: 'all'
          })
          geocoder.getAddress(e.lnglat, function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                let regeocode = result.regeocode
                let name = ''
                let content = ''
                me.center = [lng, lat]
                if (typeof (regeocode.pois[0]) !== 'undefined') {
                  name = regeocode.pois[0].name
                  content = regeocode.pois[0].name
                }
                me.list = {
                  address: regeocode.formattedAddress,
                  name: name,
                  lng: lng,
                  lat: lat,
                  city: regeocode.addressComponent.city,
                  district: regeocode.addressComponent.district,
                  township: regeocode.addressComponent.township
                }
                me.label = {
                  content: content,
                  offset: [10, 12]
                }
              }
            }
          })
        }
      },
      searchOption: {
        city: me.city,
        citylimit: true
      },
      plugin: [
        'Scale'
      ]
    }
  },
  methods: {
    closeMap () {
      this.$emit('AmapSelect')
    },
    submitMap () {
    //   console.log(this.center)
      let areaSpe = this.list.city + '/' + this.list.district + '/' + this.list.township + '/' + this.list.name
      let mapSize = this.list.lng + ',' + this.list.lat
      this.$emit('mapMsg', {mapSize: mapSize, areaSpe: areaSpe})
    },
    onSearchResult (pois) {
      // 搜索
      var me = this
    //   console.log(pois)
      if (pois && pois.length > 0) {
        // 如果长度为1则无需转化
        let poi = pois[0]
        let lng = poi['lng']
        let lat = poi['lat']
        // 这里通过高德 SDK 完成。
        var geocoder = new AMap.Geocoder({
          radius: 100,
          extensions: 'all'
        })
        geocoder.getAddress(poi.location, function (status, result) {
          console.log(result)
          if (status === 'complete' && result.info === 'OK') {
            if (result && result.regeocode) {
              let regeocode = result.regeocode
              me.center = [lng, lat]
              me.list = {
                address: regeocode.formattedAddress,
                name: regeocode.pois[0].name,
                lng: lng,
                lat: lat,
                city: regeocode.addressComponent.city,
                district: regeocode.addressComponent.district,
                township: regeocode.addressComponent.township
              }
              me.label = {
                content: regeocode.pois[0].name,
                offset: [10, 12]
              }
            }
          }
        })
      } else {
        me.list = []
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// amapSelect.vue?52c1bb0b